export default "__VITE_ASSET__Co9vZ8gm__"